import {
  GET_WORKSPACES_REQUEST,
  GET_WORKSPACES_SUCCESS,
  GET_WORKSPACES_ERROR,
  ADD_USERS_TO_WORKSPACE_REQUEST,
  ADD_USERS_TO_WORKSPACE_SUCCESS,
  ADD_USERS_TO_WORKSPACE_ERROR,
  ADD_PROVIDERS_TO_WORKSPACE_REQUEST,
  ADD_PROVIDERS_TO_WORKSPACE_SUCCESS,
  ADD_PROVIDERS_TO_WORKSPACE_ERROR,
  REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST,
  REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS,
  REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR,
  CREATE_WORKSPACE_REQUEST,
  CREATE_WORKSPACE_SUCCESS,
  CREATE_WORKSPACE_ERROR,
  DELETE_WORKSPACE_REQUEST,
  DELETE_WORKSPACE_SUCCESS,
  DELETE_WORKSPACE_ERROR
} from "../actions/workspaces";
import {
  UPDATE_WORKSPACE_DATA_REQUEST,
  UPDATE_WORKSPACE_DATA_SUCCESS,
  UPDATE_WORKSPACE_DATA_ERROR,
  UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST,
  UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS,
  UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR
} from "../actions/workspace";

const defaultState = {
  isFetching: false,
  fetchedAt: null,
  error: null,
  data: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_WORKSPACES_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }
    case GET_WORKSPACES_SUCCESS: {
      const { workspaces } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: workspaces
      };
    }
    case GET_WORKSPACES_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case UPDATE_WORKSPACE_DATA_REQUEST:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_REQUEST:
    case ADD_USERS_TO_WORKSPACE_REQUEST:
    case ADD_PROVIDERS_TO_WORKSPACE_REQUEST:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }
    case UPDATE_WORKSPACE_DATA_SUCCESS:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_SUCCESS:
    case ADD_USERS_TO_WORKSPACE_SUCCESS:
    case ADD_PROVIDERS_TO_WORKSPACE_SUCCESS:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_SUCCESS: {
      if (!state || !state.data) {
        /**
         * We may add users to workspace even if there are no workspaces fetched.
         * In this case, we skip the update, because we have nothing to update.
         */
        return state;
      }

      const { data: workspaces } = state;
      const { workspace: newWorkspace } = action;

      // Replace workspace with an updated one
      const workspaceIndex = workspaces.findIndex(oldWorkspace => oldWorkspace.id === newWorkspace.id);
      const newWorkspaces = [...workspaces];
      if (workspaceIndex !== -1) {
        newWorkspaces.splice(workspaceIndex, 1, newWorkspace);
      } else {
        // What to do if we updated a workspace that's not in the database somehow?
      }

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: newWorkspaces
      };
    }
    case UPDATE_WORKSPACE_DATA_ERROR:
    case UPDATE_WORKSPACE_PROVIDER_NOTE_ERROR:
    case ADD_USERS_TO_WORKSPACE_ERROR:
    case ADD_USERS_TO_WORKSPACE_ERROR:
    case ADD_PROVIDERS_TO_WORKSPACE_ERROR:
    case REMOVE_PROVIDERS_FROM_WORKSPACE_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case CREATE_WORKSPACE_REQUEST:
    case DELETE_WORKSPACE_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }
    case CREATE_WORKSPACE_SUCCESS:
    case DELETE_WORKSPACE_SUCCESS: {
      const { data: newWorkspaces } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: newWorkspaces
      };
    }
    case CREATE_WORKSPACE_ERROR:
    case DELETE_WORKSPACE_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    default: return state;
  }
};
